import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TimeAgo from 'timeago-react'

const Header = ({
  createdAt,
  description,
  creatorName,
  imageSrc,
  additionalMessage,
  toolbar,
}) => {
  return (
    <div className="columns p-1 is-gapless is-marginless is-vcentered is-mobile">
      {imageSrc && (
        <div className="is-pulled-left mr-1">
          <figure className={classNames('image is-64x64')}>
            <img className="is-rounded" src={imageSrc} />
          </figure>
        </div>
      )}
      <div className="column">
        <h4 className="is-size-5 is-size-6-mobile">{description}</h4>
        {createdAt && (
          <h6 className="is-size-7 has-text-grey-light">
            Created <TimeAgo datetime={createdAt} opts={{minInterval: 60}} />{' '}
            {creatorName && `by ${creatorName}`}
          </h6>
        )}
        {additionalMessage}
      </div>
      {toolbar && <div className="pull-right ml-1 is-flex">{toolbar}</div>}
    </div>
  )
}

Header.propTypes = {
  additionalMessage: PropTypes.node,
  createdAt: PropTypes.number,
  creatorName: PropTypes.string,
  description: PropTypes.string,
  imageSrc: PropTypes.string,
  toolbar: PropTypes.node,
}

export default Header
